import {Component, OnDestroy, OnInit} from '@angular/core';
import { DomSanitizer, SafeUrl} from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import {EcomanagerService} from '../ecomanager/Ecomanager.service';

@Component({
  templateUrl: './CEI.component.html',
  styleUrls: ['./CEI.component.css']
})
export class CEIComponent implements OnDestroy {

  url: SafeUrl;
  isLoading = true;
  subscription: any;

  constructor(private sanitizer: DomSanitizer, private ecomanagerService: EcomanagerService, private http: HttpClient) {

    if ( this.ecomanagerService.isLoaded() ) {
      this.isLoading = false;
      this.setUrl();
    } else {
      this.subscription = this.ecomanagerService.loadedChange$.subscribe( loaded => {
        this.isLoading = !loaded;
        if ( loaded ) {
          this.setUrl();
        }
      });
    }

  }

  setUrl() {
    const cei_user = this.ecomanagerService.getCredentialByServiceAndParam('cei', 'username');
    const cei_password = this.ecomanagerService.getCredentialByServiceAndParam('cei', 'password');
    if (cei_user != null && cei_password != null) {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl('https://altereco.wetstock.live/logon.i4?org=1&INDEX_PAGE=/login_page.jsp&' +
        'action=logon&clientReferenceId=&email=' + cei_user + '&password=' + cei_password);
    } else {
      this.url = null;
    }
  }

  ngOnDestroy(): void {
    this.logout();
    if ( this.subscription ){
      this.subscription.unsubscribe();
    }
  }

  logout() {
    let url = 'https://lobdemo.wetstock.live/logoff.i4';
    this.http.get(url)
  }
}
